/* global ja, nee , noConnection, csrf_token , view , consumer_url , currentLayout , taal , verlaatPagina */
import './react/utils/noConnection.ts';

$(document).on('click', '#schadegevallen_lijst', function () {
  const parameters =
    '&script_action=schadegevallen_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.schadegevallen' + parameters;
});

$(document).on('click', '#slimconnect_list', function () {
  const parameters = '&script_action=slimconnect_list&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.slim_connect' + parameters;
});

$(document).on('click', '#email_inbox_list', function () {
  const parameters = '&script_action=email_inbox&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.email_inbox' + parameters;
});

$(document).on('click', '#agent_search', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=agent.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_uitvalportaal', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  window.location.href = '/index.php?view=behandelaar.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_herstellerportaal', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_makelaar_werklijst', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = 'index.php?view=makelaar.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_kostenposten_makelaar', function () {
  const parameters =
    '&script_action=kostenposten_tonen&csrf_token=' + csrf_token;
  location.href = 'index.php?view=makelaar.kostenpost' + parameters;
});

$(document).on('click', '#ik_wil_naar_opdrachtgeverportaal', function () {
  const parameters = '&script_action=kj&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.zekerheid' + parameters;
});

$(document).on('click', '#open_snowflake_query', function () {
  const parameters = '&script_action=query_snowflake&csrf_token=' + csrf_token;
  location.href = '/index.php?view=administrator.snowflake' + parameters;
});

$(document).on('click', '#ik_wil_naar_tekstportaal', function () {
  const parameters = '&script_action=lijst_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=tekstschrijver.beheer' + parameters;
});

$(document).on('click', '#ik_wil_naar_consumentportaal', function () {
  const parameters =
    '&script_action=toon_persoonlijke_pagina&csrf_token=' + csrf_token;
  location.href = '/index.php?view=consument.welkom' + parameters;
});

$(document).on('click', '#ik_wil_tekst_beheren', function () {
  const parameters = '&script_action=lijst_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=tekstschrijver.beheer' + parameters;
});

$(document).on('click', '#ik_wil_gebruikers_beheren', function () {
  const parameters = '&script_action=gebruikers_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=user.gebruikersbeheer' + parameters;
});

$(document).on('click', '#ik_wil_segmenteren', function () {
  const parameters = '&script_action=kj&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.zekerheid' + parameters;
});

$(document).on('click', '#ik_wil_punten_beheren', function () {
  const parameters = '&script_action=toon_overzicht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.score' + parameters;
});

$(document).on('click', '#ik_wil_uitvalregels_beheren', function () {
  const parameters = '&script_action=toon_overzicht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.uitvalregels' + parameters;
});

$(document).on('click', '#ik_wil_gebruikers_beheren', function () {
  const parameters = '&script_action=toon_gebruikers&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.gebruiker' + parameters;
});

$(document).on('click', '#ik_wil_data_exporteren', function () {
  const parameters = '&script_action=test&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.data_export' + parameters;
});

$(document).on('click', '#ik_wil_csv_exporteren', function () {
  const parameters = '&script_action=csv&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.data_export' + parameters;
});

$(document).on('click', '#ik_wil_parametriseren', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.parameters' + parameters;
});

$(document).on('click', '#ik_wil_unieke_teksten', function () {
  const parameters = '&script_action=default&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.teksten' + parameters;
});

$(document).on('click', '#ik_wil_tikken_cat_zien', function () {
  const parameters =
    '&script_action=toon_tikken_categories&csrf_token=' + csrf_token;
  location.href = '/index.php?view=opdrachtgever.tikken' + parameters;
});

$(document).on('click', '#ik_wil_naar_herstelopdracht', function () {
  const parameters =
    '&script_action=toon_herstelopdracht&csrf_token=' + csrf_token;
  location.href =
    '/index.php?view=herstelregisseur.herstelopdracht' + parameters;
});

$(document).on('click', '#ik_wil_naar_wachtwoord', function () {
  const parameters =
    '&script_action=wachtwoord_vragen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=user.wachtwoord' + parameters;
});

$(document).on('click', '#ik_wil_naar_schedule', function () {
  const parameters = '&script_action=set_schedule&csrf_token=' + csrf_token;
  location.href = '/index.php?view=user.wachtwoord' + parameters;
});

$(document).on('click', '#ik_wil_naar_dossier_herstel', function () {
  const parameters = '&script_action=dossier_inzien&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.dossier' + parameters;
});

$(document).on('click', '#ik_wil_naar_herstel_werklijst', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_expert_werklijst', function () {
  const parameters = '&script_action=toon_lijst&csrf_token=' + csrf_token;
  location.href = '/index.php?view=expert.werklijst' + parameters;
});

$(document).on('click', '#ik_wil_naar_kostenposten', function () {
  const parameters =
    '&script_action=kostenposten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.kostenpost' + parameters;
});

$(document).on('click', '#ik_wil_naar_kostenposten_behandelaar', function () {
  const parameters =
    '&script_action=kostenposten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.herstelopdracht' + parameters;
});

$(document).on('click', '#ik_wil_naar_kostenposten_expert', function () {
  const parameters =
    '&script_action=kostenposten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=expert.kostenpost' + parameters;
});

$(document).on('click', '#submit_zoekformulier', function () {
  const zoekwaarde = $('#zoekwaarde').val();
  location.href =
    '/index.php?view=behandelaar.werklijst&script_action=zoekresultaten_weergeven&zoekwaarde=' +
    zoekwaarde +
    '&csrf_token=' +
    csrf_token +
    '#zoekresultaten_weergeven';
});

$(document).on('click', '#ik_wil_zoeken', function () {
  location.href =
    '/index.php?view=behandelaar.werklijst&script_action=zoekformulier_weergeven&csrf_token=' +
    csrf_token +
    '#zoekformulier_weergeven';
});

$(document).on('click', '#ik_wil_naar_uitvalcluster', function () {
  const parameters =
    '&script_action=toon_uitvalopdracht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.uitvalopdracht' + parameters;
});

$(document).on('click', '#ik_wil_naar_beslissing', function () {
  const parameters = '&script_action=toon_beslissing&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.uitvalopdracht' + parameters;
});

$(document).on('click', '#ik_wil_naar_beslissing_makelaar', function () {
  location.href =
    '/index.php?view=makelaar.herstelopdracht&script_action=toon_herstelopdracht&csrf_token=' +
    csrf_token;
});

$(document).on(
  'click',
  '#ik_wil_naar_beslissing_herstelregisseur',
  function () {
    const parameters =
      '&script_action=toon_herstelopdracht&csrf_token=' + csrf_token;
    location.href =
      'index.php?view=herstelregisseur.herstelopdracht' + parameters;
  }
);

$(document).on('click', '#ik_wil_naar_actie', function () {
  const parameters = '&script_action=acties_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.actie' + parameters;
});

$(document).on('click', '#ik_wil_naar_schadevaststelling', function () {
  const parameters =
    '&script_action=schadeposten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.schadevaststelling' + parameters;
});

$(document).on(
  'click',
  '#ik_wil_naar_schadevaststelling_herstelregisseur',
  function () {
    const parameters =
      '&script_action=schadeposten_tonen&csrf_token=' + csrf_token;
    location.href =
      'index.php?view=herstelregisseur.schadevaststelling' + parameters;
  }
);

$(document).on('click', '#ik_wil_naar_schadevaststelling_expert', function () {
  const parameters =
    '&script_action=schadeposten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=expert.schadevaststelling' + parameters;
});

$(document).on('click', '#ik_wil_naar_brief', function () {
  const parameters =
    '&script_action=notificaties_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.brief' + parameters;
});

$(document).on('click', '#ik_wil_naar_notificatie', function () {
  const parameters =
    '&script_action=notificaties_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.notificatie' + parameters;
});

$(document).on('click', '#ik_wil_naar_contactmoment', function () {
  const parameters =
    '&script_action=contactmomenten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.contactmoment' + parameters;
});

$(document).on('click', '#ik_wil_naar_contactmoment_hersteller', function () {
  const parameters =
    '&script_action=contactmomenten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.contactmoment' + parameters;
});

$(document).on('click', '#ik_wil_naar_contactmoment_makelaar', function () {
  const parameters =
    '&script_action=contactmomenten_tonen&csrf_token=' + csrf_token;
  location.href = '/index.php?view=makelaar.contactmoment' + parameters;
});

$(document).on('click', '#ik_wil_naar_bestanden', function () {
  const parameters =
    '&script_action=bestanden_overzicht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.bestanden' + parameters;
});

$(document).on('click', '#ik_wil_naar_bestanden_makelaar', function () {
  const parameters =
    '&script_action=bestanden_overzicht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=makelaar.bestanden' + parameters;
});

$(document).on('click', '#ik_wil_naar_bestanden_hersteller', function () {
  const parameters =
    '&script_action=bestanden_overzicht&csrf_token=' + csrf_token;
  location.href = '/index.php?view=herstelregisseur.bestanden' + parameters;
});

$(document).on('click', '#ik_wil_naar_dossier_behandelaar', function () {
  const parameters = '&script_action=dossier_inzien&csrf_token=' + csrf_token;
  location.href = '/index.php?view=behandelaar.dossier' + parameters;
});

$(document).on('click', '#ik_wil_naar_behandel_werklijst', function () {
  const parameters =
    '&script_action=toon_lijst&csrf_token=' + csrf_token + '#toon_lijst';
  location.href = '/index.php?view=behandelaar.werklijst' + parameters;
});

$(document).on(
  'click',
  '#ik_wil_uitloggen, input[type=button]#uitlogknop',
  function () {
    $('#dialog').dialog({
      title: window.translator.t('weet_u_het_zeker'),
      resizable: false,
      height: 240,
      modal: true,
      buttons: [
        {
          text: ja,
          click: function () {
            let parameters = 'script_action=uitloggen&csrf_token=' + csrf_token;
            verlaatPagina(view);
            if (
              view.indexOf('consument.') != -1 ||
              view.indexOf('gedelegeerde.') != -1
            ) {
              parameters = parameters + '&portal=front';
            } else {
              parameters = parameters + '&portal=back';
            }

            $.post(
              consumer_url + 'views/user.login.php',
              parameters,
              function () {
                let redirectTarget;
                if (view.indexOf('consument.') != -1) {
                  redirectTarget =
                    'index.php?view=consument.tot_ziens&script_action=tot_ziens&&taal=' +
                    taal;
                } else if (view.indexOf('gedelegeerde.') != -1) {
                  redirectTarget =
                    'index.php?view=gedelegeerde.tot_ziens&script_action=tot_ziens&taal=' +
                    taal;
                } else {
                  redirectTarget =
                    'index.php?template=' +
                    currentLayout +
                    '&view=user.tot_ziens&script_action=tot_ziens&taal=' +
                    taal;
                }

                location.href = consumer_url + redirectTarget;
              }
            ).fail(function (jqXHR, textStatus, errorThrown) {
              noConnection(textStatus, errorThrown);
            });
            $(this).dialog('close');
          },
        },
        {
          text: nee,
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
    $('#dialog').html(window.translator.t('weet_u_het_zeker_uitloggen'));
    $('#dialog').dialog('open');
  }
);

$(document).on('click', '#repairer_manual', function () {
  window.open(
    'https://emsclaimsengine.atlassian.net/wiki/spaces/KEN/overview',
    '_blank'
  );
});
